import { State } from 'store'

export const isSidebarOpen = (state: State) => state.sidebar.open
